import {getCurrentYear} from '../../utils/commons'
import BestValueRankingsLogo from './logo'
import {bestValueRankingsStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestvaluerankings' as const,
  domainType: 'deals' as const,
  siteName: 'Best Value Rankings',
  favicon: '/favicons/bestvaluerankings.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-NN4ZPVBFXP',
    camelCaseUrl: 'BestValueRankings.com',
    logo: <BestValueRankingsLogo className="size-10 shrink-0 tablet:size-8" />,
    title: (category: string, count: string) =>
      `Best ${count} ${category} to Buy in ${getCurrentYear()} | BestValueRankings.com - Honest Reviews & Top Picks`,
    description: (category?: string, count?: string) =>
      `Explore the best ${count} ${category} for ${getCurrentYear()} at BestValueRankings.com. Honest expert reviews, detailed comparisons, and smart shopping tips for better value.`,
    styles: bestValueRankingsStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
